import { useConvertPartsMutation } from '../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useConvertPartsHandler( options?: any ) {
	const [ convertParts ] = useConvertPartsMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( storePart: { part: { id: string }, inventoryLocation: { id: string } }, toPartId: string, quantity: number ) => {
		const inventoryLocationId = storePart?.inventoryLocation.id
		const fromPartId = storePart?.part.id

		const result = await convertParts( { variables: { inventoryLocationId, fromPartId, toPartId, quantity } } )
		if ( result.data?.convertParts?.success ) {
			showSuccess( `convertPartsSuccess${Date.now()}`, result.data?.convertParts?.message ?? 'Successfully converted part' )
		} else {
			showError( `convertPartsError${Date.now()}`, result.data?.convertParts?.message ?? 'Sorry, an error occurred' )
		}
	}
}
